import {
    TCustomInteractionValues,
    TFilter, TInteractionValues,
    TLastActivityValues,
    TNftResponseValues,
    TTokenValues,
    TWalletWealthValues
} from "@/types/filterBlocks/filterBlockTypes";
import {TTokenFilteringRules} from "@/types/services/filtration/request/token/tokenFilteringRulesTypes";
import {TWalletWealthFilteringRules} from "@/types/services/filtration/request/wallet/walletWealthFilteringRulesTypes";
import {TNftFilteringRules} from "@/types/services/filtration/request/nft/nftFilteringRulesTypes";
import {
    TLastActivityFilteringRules
} from "@/types/services/filtration/request/activity/lastActivityFilteringRulesTypes";
import {getLastActivityDate} from "@/utils/getLastActivityDate";
import {
    TSpecificInteractionFilteringRules
} from "@/types/services/filtration/request/interaction/specificInteractionFilteringRulesTypes";
import {
    TCustomInteractionFilteringRules
} from "@/types/services/filtration/request/customInteraction/customInteractionFilteringRulesTypes";
import {validContractAddress} from "@/utils/validContractAddress";

export const convertFilterValueForAPI = (filterValues: TFilter) => {
    const values = filterValues.data.values;
    const type = filterValues.type;
    const requestValues = () => {
        switch (type) {
            case "token":
                const tokenValues: TTokenFilteringRules = Object.entries(values as TTokenValues)
                    .map(([_token_name, value]) => ({
                        contract_address: value.contract_address,
                        min_amount: value.min_amount,
                        chain: value.chain,
                    }));
                return tokenValues
            case "wallet_wealth":
                const walletWealthValues: TWalletWealthFilteringRules = Object.entries(values as TWalletWealthValues)
                    .map(([chain, values]) => ({
                        min: values[0],
                        max: values[1],
                        chain: chain === 'values' ? null : chain,
                    }));
                return walletWealthValues
            case "nft":
                const nftValues: TNftFilteringRules = Object.entries(values as TNftResponseValues)
                    .map(([_name, item]) => ({
                        contract_address: item.contract_address,
                        chain: item.chain,
                    }))
                return nftValues
            case "last_activity":
                const lastActivityValues: TLastActivityFilteringRules = Object.entries(values as TLastActivityValues)
                    .map(([chain, value]) => ({
                        chain: chain === 'value' ? null : chain,
                        last_activity_date: getLastActivityDate(value) || '',
                    }))
                    .filter((item) => item.last_activity_date !== '')
                return lastActivityValues
            case "interaction":
                const interactionValues: TSpecificInteractionFilteringRules = Object.entries(values as TInteractionValues)
                    .flatMap(([chain, interactions]) => {
                        return interactions.map((interaction) => ({
                            chain: chain === 'value' ? null : chain,
                            function_name: interaction
                        }))
                    })
                    .filter((item) => item.function_name !== '')
                return interactionValues
            case "custom_interaction":
               const customInteractionValues: TCustomInteractionFilteringRules = (values as TCustomInteractionValues)
                    .map((item) => {
                        return {
                            function_name: item.interaction_name === '' ? 'untitled' : item.interaction_name,
                            contract_address: validContractAddress(item.contract_address) ? item.contract_address : '',
                        }
                    })
                    .filter((item) => item.contract_address !== '')
                return customInteractionValues
        }
    }
    return requestValues()
}